import { useReapitConnect } from '@reapit/connect-session'
import { FlexContainer, NavResponsive } from '@reapit/elements'
import React, { useMemo } from 'react'
import { Outlet, useNavigate } from 'react-router'
import { reapitConnectBrowserSession } from '../reapit-connect-session'
import { getAbbreviation } from '@reapitform/utils'
import { css } from '@linaria/core'

const mainNavStyle = css`
  .el-nav-responsive-avatar-wrap {
    span.el-intent-default.el-icon-new.el-icon {
      display: none;
    }
  }
`
const MainLayout: React.FC = () => {
  const { connectSession, connectLogoutRedirect } = useReapitConnect(reapitConnectBrowserSession)

  const navigate = useNavigate()
  const handleLogoClick = () => navigate('/')
  const userName = useMemo(
    () => getAbbreviation(connectSession?.loginIdentity.name || ''),
    [connectSession?.loginIdentity.name],
  )

  return (
    <FlexContainer isFlexColumn isFlexGrow1>
      <NavResponsive
        className={mainNavStyle}
        avatarText={userName}
        defaultNavIndex={0}
        options={[
          {
            callback: handleLogoClick,
            itemIndex: 0,
          },
        ]}
        avatarOptions={[
          {
            callback: () => navigate('/profile'),
            text: 'Profile',
          },
          {
            callback: () => navigate('/setting'),
            text: 'Settings',
          },
          {
            callback: () => navigate('/agreement'),
            text: 'Agreements',
          },
          {
            callback: () => navigate('/default'),
            text: 'Defaults',
          },
          {
            callback: () => connectLogoutRedirect(),
            text: 'Log out',
          },
        ]}
      />
      <FlexContainer isFlexColumn isFlexGrow1>
        <Outlet />
      </FlexContainer>
    </FlexContainer>
  )
}

export default MainLayout
